import { ComponentType, ReactNode } from "react";
import { SubscriptionRewardDescription } from "../ChallengeDetail/Descriptions/SubscriptionRewardDescription";
import { EnterTheRegularDrawDescription } from "../ChallengeDetail/Descriptions/EnterTheRegularDrawDescription";
import { EnterTheRareDrawDescription } from "../ChallengeDetail/Descriptions/EnterTheRareDrawDescription";
import { GetSalaryDescription } from "../ChallengeDetail/Descriptions/GetSalaryDescription";
import { SubscribeMainChannelDescription } from "../ChallengeDetail/Descriptions/SubscribeMainChannelDescription";
import { UpgradeWorkDescription } from "../ChallengeDetail/Descriptions/UpgradeWorkDescription";
import { StartBusinessDescription } from "../ChallengeDetail/Descriptions/StartBusinessDescription";
import { UpgradeBusinessCharsDescription } from "../ChallengeDetail/Descriptions/UpgradeBusinessCharsDescription";
import { UpgradeBusinessElementsDescription } from "../ChallengeDetail/Descriptions/UpgradeBusinessElementsDescription";
import { ChallengeDetailTicketProgress } from "../ChallengeDetail/Progress/ChallengeDetailTicketProgress";
import { ChallengeDetailProgress } from "../ChallengeDetail/Progress/ChallengeDetailProgress";
import { TakePartQuizDescription } from "../ChallengeDetail/Descriptions/TakePartQuizDescription";
import { JoinChannelsDescription } from "../ChallengeDetail/Descriptions/JoinChannelsDescription";
import { WheelOfFortuneDescription } from "../ChallengeDetail/Descriptions/WheelOfFortuneDescription";
import { AddHomescreenShortcutDescription } from "../ChallengeDetail/Descriptions/AddHomescreenShortcutDescription";
import { EnterTheEpicDrawDescription } from "../ChallengeDetail/Descriptions/EnterTheEpicDrawDescription";
import { EnterTheLegendaryDrawDescription } from "../ChallengeDetail/Descriptions/EnterTheLegendaryDrawDescription";
import { BuyBoostDescription } from "../ChallengeDetail/Descriptions/BuyBoostDescription";
import { InviteFriendDescription } from "../ChallengeDetail/Descriptions/InviteFriendDescription";
import { CompleteRegularCollectionDescription } from "../ChallengeDetail/Descriptions/CompleteRegularCollectionDescription";
import { CompleteRareCollectionDescription } from "../ChallengeDetail/Descriptions/CompleteRareCollectionDescription";
import { CompleteEpicCollectionDescription } from "../ChallengeDetail/Descriptions/CompleteEpicCollectionDescription";
import { InteractiveDrawPrizesLevelDescription } from "../ChallengeDetail/Descriptions/InteractiveDrawPrizesLevelDescription";
import { FragmentsDrawPrizesLevelDescription } from "../ChallengeDetail/Descriptions/FragmentsDrawPrizesLevelDescription";
import { AutomaticDrawPrizesLevelDescription } from "../ChallengeDetail/Descriptions/AutomaticDrawPrizesLevelDescription";

export interface IChallengeView {
    id: number;
    cardDescription: ReactNode;
    progress: ComponentType<{ progress: number, total: number, label?: string }>;
    progressLabel?: string;
}

const CHALLENGE_CONFIG = [
    { id: 1, description: SubscriptionRewardDescription, progress: ChallengeDetailTicketProgress },
    { id: 2, description: EnterTheRegularDrawDescription },
    { id: 3, description: EnterTheRareDrawDescription },
    { id: 4, description: EnterTheEpicDrawDescription },
    { id: 5, description: EnterTheLegendaryDrawDescription },
    { id: 6, description: GetSalaryDescription },
    { id: 7, description: SubscribeMainChannelDescription },
    { id: 8, description: UpgradeWorkDescription },
    { id: 9, description: StartBusinessDescription },
    { id: 10, description: UpgradeBusinessCharsDescription },
    { id: 11, description: UpgradeBusinessElementsDescription },
    { id: 12, description: TakePartQuizDescription },
    { id: 13, description: JoinChannelsDescription },
    { id: 14, description: WheelOfFortuneDescription },
    { id: 15, description: AddHomescreenShortcutDescription },
    { id: 16, description: BuyBoostDescription },
    { id: 17, description: InviteFriendDescription },
    { id: 18, description: CompleteRegularCollectionDescription },
    { id: 19, description: CompleteRareCollectionDescription },
    { id: 20, description: CompleteEpicCollectionDescription },

    { id: 101, description: InteractiveDrawPrizesLevelDescription, progressLabel: 'участников' },
    { id: 102, description: FragmentsDrawPrizesLevelDescription, progressLabel: 'участников' },
    { id: 103, description: AutomaticDrawPrizesLevelDescription, progressLabel: 'участников' },
];

export const challengesData: IChallengeView[] = CHALLENGE_CONFIG.map(config => ({
    id: config.id,
    cardDescription: <config.description />,
    progress: config.progress || ChallengeDetailProgress,
    progressLabel: config.progressLabel,
}));